module.exports = __webpack_public_path__ + "static/media/baby-branco.79c4d6dd.webp";